
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../Helper/ToastMessage";

// Get Table Data
export const DailyPreventiveWorkTableDataAPI = createAsyncThunk("DailyPreventiveWorkTableData", async ({ data }) => {
    const {
        M_WardID,
        FromkDate,
        TokDate,
        M_UsersID,
        token,
        From,
        To,
        Flag,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_GD_T_KPIUploadPreventiveWork_Select?M_WardID=${M_WardID ? M_WardID : '1'}&FromkDate=${FromkDate}&TokDate=${TokDate}&M_UsersID=${M_UsersID}&Flag=${Flag}&From=${From}&To=${To}`, requestOptions)
     
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const DailyPreventiveWorkTableDataSlice = createSlice({
    name: "DailyPreventiveWorkTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(DailyPreventiveWorkTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(DailyPreventiveWorkTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(DailyPreventiveWorkTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const DailyPreventiveWorkTableDataReducer = DailyPreventiveWorkTableDataSlice.reducer

export const DailyPreventiveWorkExportTableDataAPI = createAsyncThunk("DailyPreventiveWorkExportTableData", async ({ data }) => {
    const {
        M_WardID,
        FromkDate,
        TokDate,
        M_UsersID,
        token,
        From,
        To,
        Flag,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_GD_T_KPIUploadPreventiveWork_Select?M_WardID=${M_WardID ? M_WardID : '1'}&FromkDate=${FromkDate}&TokDate=${TokDate}&M_UsersID=${M_UsersID}&Flag=${Flag}&From=${From}&To=${To}`, requestOptions)
     
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const DailyPreventiveWorkExportTableDataSlice = createSlice({
    name: "DailyPreventiveWorkTableData",
    initialState: {
        isExportLoading: false,
        DailyPreventiveWorkTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(DailyPreventiveWorkExportTableDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(DailyPreventiveWorkExportTableDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.DailyPreventiveWorkTableData = action.payload;
        });
        builder.addCase(DailyPreventiveWorkExportTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.DailyPreventiveWorkTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const DailyPreventiveWorkExportTableDataReducer = DailyPreventiveWorkExportTableDataSlice.reducer


